// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"fc0dcfa1","161":"5bf32efd","275":"eb394666","544":"9c40df5a","561":"30257205","805":"7bcc31bc","884":"ef49e9d9"}[chunkId] + ".chunk.js";
};